<template>
	<div class="h-full mb-4" :class="borderClass">
		<div :class="outerClass">
			<!-- Image Section -->
			<div class="text-center col-span-2 lg:col-span-1">
				<img :src="`${urlLocation}/services/lawn-care/service-lawn-care-preferred-program-600x600.webp`"
					:class="imageClasses" style="max-height:330px" />
			</div>

			<!-- Description Section -->
			<div :class="descriptionClass">

				<h2 class="pb-2 txt-00810e">{{ service.Name }}</h2>
				<p style="font-size: 1rem;line-height: 1.5;" v-html="service.PackageFODesc">
				</p>

				<!-- Toggle Visibility -->
				<div class="py-4 toggle-visibility" @click="toggleVisibility" style="cursor:pointer">
					<span>
						<svg v-show="!isExpanded" xmlns="http://www.w3.org/2000/svg" class="icon mr-1 pl-1" fill="none"
							viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="display:inline">
							<path stroke-linecap="round" stroke-linejoin="round"
								d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
						</svg>
						<svg v-show="isExpanded" xmlns="http://www.w3.org/2000/svg" class="icon mr-1 pl-1" fill="none"
							viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="display:inline">
							<path stroke-linecap="round" stroke-linejoin="round"
								d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
						</svg>
					</span>
					What's Included?
				</div>

				<!-- Expanded Content -->
				<div v-show="isExpanded">
					<h3 class="py-4">The Preferred Lawn Care Program and Popular Add-ons</h3>
					<!-- <p class="py-2" style="font-size: 1rem;line-height: 1.5;">The Premium Package with our most popular
						lawn care
						program plus even better add-ons.</p> -->

					<!-- Add-ons Section -->
					<div class="rounded p-4 mb-4" style="border:1px solid #00953A">
						<h3 class="txt-00953A pb-4 pl-4">Included Add-ons</h3>
						<div class="flex" style="flex-direction: column;">
							<div v-for="(item, index) in service['Programs and Services']" :key="index"
								class="txt-00953A py-2 flex" style=" align-items:center;">

								<span class="icon" style="display:inline-table">
									<svg class="icon mx-1 check-icon" viewBox="0 0 24 24">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
											clip-rule="evenodd" />
									</svg>
								</span>
								<span>
									<span v-html="item['ServiceDesc']"></span>
									<span :title="serviceDefId(item.fk_ServiceDefId)" style="display: ruby;">
										<svg viewBox="0 0 24 24" class="small-icon info-icon ">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</span>
							</div>
						</div>
					</div>

					<p style="font-size: 1rem;line-height: 1.5;">
						<b>Perfect For:</b> Lawn enthusiasts who want comprehensive care that addresses every detail. If
						you're
						aiming for premium, year-round beauty, this is your package.
					</p>
				</div>
			</div>

			<!-- Add to Cart -->
			<div :class="addToCartClass">
				<a v-if="packageSavings" class="button button-white mb-4 packageSavings-button" @click.stop.prevent>
					Save up to {{ formatPrice(packageSavings) }}! </a>

				<h1 class="txt-00953A m-0"> {{ formatPrice(packagePrice) }} </h1>
				<div style="font-size: 0.80rem;" class="txt-00953A pb-2">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
						stroke="currentColor" class="information-icon small-icon"
						style="display:inline;cursor: pointer; color: #fff;" @click.stop.prevent="monthlyModal()">
						<path stroke-linecap="round" stroke-linejoin="round"
							d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
					</svg>
					<span>Per Month</span>
				</div>

				<a class="button addtocart" @click.stop.prevent="addToCart()"
					v-bind:class="{ 'button-added addedtocart': isOrderPremiumPackage && currentPackageId }">
					{{ addToCartText }} </a>

			</div>
		</div>

		<!-- Toast and Modals -->
		<Toast v-if="showToast" @hideToast="toggleToast"> {{ message }} </Toast>

		<PackageCardModal ref="packageCardModal" :serviceName="service.Name" :price="packagePrice"></PackageCardModal>

		<MonthlyDetailsModal ref="monthlyDetailModal" />
	</div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import MonthlyDetailsModal from './MonthlyDetailsModal.vue';
import PackageCardModal from './PackageCardModal.vue';
import { getFormattedPrice } from '~/utils/payment';
import type State from '~/domains/store/State';
import { computed } from 'vue';

const store: Store<State> = useStore();
const { $config, $orders, $services } = useNuxtApp();

const props = defineProps({
	size: {
		type: String,
		default: 'md',
	},
	service: {
		type: Object,
		required: true,
	},
});

const monthlyDetailModal = ref<InstanceType<typeof MonthlyDetailsModal>>();
const packageCardModal = ref<InstanceType<typeof PackageCardModal>>();
const persistedState = computed(() => store.state.persistedState);

const showToast = ref(false);
const message = ref('There was a problem. Please try again at another time.');
const isExpanded = ref(true);
const borderClass = ref("red-stroke mb-6");
const outerClass = ref("grid md:grid-cols-1 lg:grid-cols-4 bg-white rounded text-center lg:text-left");
const descriptionClass = ref("lg:col-span-2 px-8 pt-8 pb-4 text-left");
const addToCartClass = ref("px-8 pt-8 pb-4 text-center col-span-2 lg:col-span-1");
const imageClasses = ref("rounded service-image-square");
const urlLocation = ref($config.public.sgCmsImage);

const premiumPackageInfo = computed(() => {
	return store.state.persistedState?.packages?.premiumPackageInfo;
});

const currentPackageId = computed(() => {
	return store.state.persistedState?.packageId;
});

const packagePrice = computed(() => {
	let PNameID = props.service.PNameID;

	const packageInfoArray = Array.isArray(premiumPackageInfo.value) ? premiumPackageInfo.value : [];
	const filteredPackagePrice = packageInfoArray.filter(
		(item: any) => item.PNameID === PNameID
	);

	return filteredPackagePrice[0]?.price ?? NaN;
});

const packageSavings = computed(() => {
	let PNameID = props.service.PNameID;

	const packageInfoArray = Array.isArray(premiumPackageInfo.value) ? premiumPackageInfo.value : [];
	const filteredPackagePrice = packageInfoArray.filter(
		(item: any) => item.PNameID === PNameID
	);

	return (filteredPackagePrice[0]?.regularPrice - filteredPackagePrice[0]?.price) * 12; // months to year conversion
});

const isOrderPremiumPackage = computed(() => {
	const persistedState = store.state.persistedState;
	const orderItems = persistedState?.order?.orderItems || [];
	const packageId = persistedState?.packageId || "";
	let PNameID = props.service.PNameID;

	return store.state.persistedState?.packages?.isOrderPremiumPackage && orderItems.length > 0 && (packageId == PNameID);
});

const addToCartText = computed(() => {
	return isOrderPremiumPackage.value ? "Added To Cart" : "Add to cart";
});

const toggleToast = () => {
	showToast.value = !showToast.value;
};

const toggleVisibility = () => {
	isExpanded.value = !isExpanded.value;
};

const stripHtmlTags = (htmlString: string) => {
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = htmlString;
	return tempDiv.textContent || tempDiv.innerText || "";
};

const serviceDefId = (serviceDefId: number) => {
	const serviceData = store.state.persistedState?.serviceData;
	const htmlString = serviceData?.services?.[serviceDefId]?.ServiceDesc || "";
	return stripHtmlTags(htmlString);
};

const monthlyModal = () => {
	monthlyDetailModal.value?.show();
};


const removeCurrentPackage = async () => {
	const persistedState = store.state.persistedState;

	if (persistedState?.packageId) {
		try {
			store.commit('SET_SHOW_LOADER', true);

			await $orders.deletePackageOrder(
				persistedState.order.id,
				persistedState?.packageId,
				persistedState.scope.id,
				store
			);

		} catch (err) {
			console.error(err);
		} finally {
			store.commit('SET_SHOW_LOADER', false);
		}
	}
};

const addToCart = async () => {

	// if (currentPackageId.value) {
	// 	return;
	// }

	await removeCurrentPackage();

	const persistedState = store.state.persistedState;
	store.commit("SET_SHOW_LOADER", true);

	const createPackageOrder = await $orders.createPackageOrder(
		persistedState.order.id,
		props.service.PNameID,
		persistedState.scope.id
	);

	if (createPackageOrder.id) {
		packageCardModal.value?.show();
		store.commit('SET_ORDER_INFORMATION', createPackageOrder);
		store.dispatch("updatePackageId", createPackageOrder.packageId);
		$services.applyOrders();
	} else {
		message.value = "There was an unknown error while creating a new Package order. Please try again later.";
		showToast.value = true;
	}

	const isPremiumPackageAvailable = await $orders.IsPremiumPackageAvailable(persistedState?.order?.id);
	store.dispatch("updateIsOrderPremiumPackage", isPremiumPackageAvailable);

	store.commit("SET_SHOW_LOADER", false);
};

const formatPrice = (value: number) => {
	if (typeof value === "number") {
		return getFormattedPrice(value);
	}
	return value;
};

</script>

<style scoped>
.discountBgColor {
	background: linear-gradient(180deg, #4da43a 0%, #25590b 100%);
	-webkit-text-fill-color: white;
}

.red-stroke {
	background: #fff;
	border-radius: 10px;
}

.small-icon {
	width: 20px;
	height: 20px;
}

.icon {
	width: 25px;
	height: 25px;
}

.check-icon,
.information-icon {
	fill: #00810e;
}

.txt-00953A {
	color: #00953A;
}

.txt-00810e {
	color: #00810e;
}

.info-icon {
	fill: #517185;
}

.addtocart {
	background-color: #ce4200;
	padding-bottom: 1rem;
	padding-top: 1rem;
	font-weight: 600;
	font-size: 0.95rem;
	cursor: pointer;
}

.addedtocart {
	background-color: transparent;
	color: #ce4200;
	border: 2px solid #ce4200;
}

.addtocart:hover {
	background-color: #ce4200e3;
	color: white;
	/* border: 2px solid #ce4200; */
}

.packageSavings-button {
	color: #00953A;
	font-weight: bold;
	font-size: 1.1rem;
	border-radius: 0;
	border-bottom-right-radius: 30px;
	border-top-left-radius: 30px;
	padding: 0.9rem;
}

.packageSavings-button:hover {
	color: #fff !important;
}
</style>
